import { useEffect, useState } from "react";
import { Datepicker } from "@mobiscroll/react";
import SearchIcon from "../../assets/img/search.svg";
import { api } from "../../api";
import Form from "react-bootstrap/Form";
import {
  AppointmentGroupFormData,
  AppointmentMetaData,
  IdNamePair,
  PatientDetails,
  ToasterObject,
} from "./interface-utils";
import {
  AppointmentCategory,
  IdLabelPair,
  Patient,
} from "../../api/api-mockups/interfaces";
import { formateDate } from "./dateFormat";
import AsyncTypeahead, { DataListType } from "../../components/AsyncTypeahead";

type Reschedule = {
  isSchedule: boolean;
  appointmentCategory: string;
};

type AddAppointmentProps = {
  setOpenToaster: (toasterConfig: ToasterObject) => void;
  getAllAppointments?: () => void;
  isReschedule?: Reschedule;
};

// eslint-disable-next-line react/prop-types
const AddGroupWebinar: React.FC<AddAppointmentProps> = ({
  setOpenToaster,
  getAllAppointments,
  isReschedule,
}) => {
  const initialAppointmentData: AppointmentGroupFormData = {
    patients: [],
    appointmentType: "",
    appointmentMode: "",
    coachList: [],
    appointmentDatetime: "",
    appointmentTimezone: "",
    occurrence: "",
    notes: "",
    appointmentCategory: "",
    joiningLink:""
  };

  const initialPatientDetails: PatientDetails = {
    name: "",
    dob: "",
    emailList: [],
    contactList: [],
  };

  const initialAppointmentMetaData: AppointmentMetaData = {
    appointmentOccurrenceList: [],
    appointmentModes: [],
    appointmentTypeList: [],
  };

  const [radioOption, setRadioOption] = useState("OneOne");
  const [addAppointmentForm, setAddAppointmentForm] =
    useState<AppointmentGroupFormData>(initialAppointmentData);
  const [filteredPatients, setFilteredPatients] = useState<IdNamePair[]>([]);
  const [filteredCoaches, setFilteredCoaches] = useState<IdNamePair[]>([]);
  const [selectedPatientName, setSelectedPatientName] = useState("");
  const [selectedCoachName, setSelectedCoachName] = useState("");
  const [selectedPatientDetails, setSelectedPatientDetails] =
    useState<PatientDetails>(initialPatientDetails);
  const [allAppointmentTypeList, setAllAppointmentTypeList] = useState<
    AppointmentCategory[]
  >([]);
  const [appointmentMetaData, setAppointmentMetaData] =
    useState<AppointmentMetaData>(initialAppointmentMetaData);
    const [validated, setValidated] = useState(false);
    const [coachList, setCoachList] = useState<DataListType[]>([]);

  useEffect(() => {
    if (isReschedule) {
      setRadioOption(isReschedule.appointmentCategory);
    }
    getAllAppointmentsTypes();
    getAppointmentModes();
    getAppointmentOccurrenceList();
  }, []);

  useEffect(() => {
    setAddAppointmentForm(initialAppointmentData);
    setSelectedPatientDetails(initialPatientDetails);
    setAppointmentTypesOnCategoryChange();
    setSelectedPatientName("");
    setSelectedCoachName("");
  }, [radioOption, allAppointmentTypeList]);

  const setAppointmentTypesOnCategoryChange = () => {
    let appointmentTypeList;
    setAddAppointmentForm({
      ...addAppointmentForm,
      appointmentCategory: "Group Appointment",
    });
    if (allAppointmentTypeList.length > 0) {
      appointmentTypeList = allAppointmentTypeList.filter(
        (data) => data.appointmentCategory === "Group"
      )[0].types;
    }
    if (appointmentTypeList) {
      setAppointmentMetaData({
        ...appointmentMetaData,
        appointmentTypeList: appointmentTypeList,
      });
    }
  };

  const getSearchPatientList = async (searchQuery: string) => {
    setSelectedPatientName(searchQuery);
    if (searchQuery.length >= 3) {
      try {
        const data = await api.getSearchPatientList(searchQuery);
        //TODO: Remove when actual API is integrated
        filterPatientList(data, searchQuery);
      } catch (error) {}
    } else setFilteredPatients([]);
  };
  const getSearchCoachList = async (searchQuery: string) => {
    setSelectedCoachName(searchQuery);
    if (searchQuery.length >= 3) {
      try {
        const data = await api.getSearchCoachList(searchQuery);
        //TODO: Remove when actual API is integrated
        filterCoachList(data, searchQuery);
      } catch (error) {}
    } else setFilteredCoaches([]);
  };

  const getAppointmentModes = async () => {
    try {
      const data = await api.getAppointmentModes();
      console.log(data);
      setAppointmentMetaData({
        ...appointmentMetaData,
        appointmentModes: data,
      });
      console.log(appointmentMetaData);
    } catch (error) {}
  };
  const getAppointmentOccurrenceList = async () => {
    try {
      const data = await api.getAppointmentOccurrenceList();
      setAppointmentMetaData({
        ...appointmentMetaData,
        appointmentOccurrenceList: data,
      });
    } catch (error) {}
  };
  const getAllAppointmentsTypes = async () => {
    try {
      const data = await api.getAllAppointmentsTypes();
      setAllAppointmentTypeList(data);
      setAppointmentTypesOnCategoryChange();
    } catch (error) {}
  };
  const getPatientDetailById = async (id: number) => {
    try {
      const data: Patient = await api.getPatientDetailById(id);
      //   setPatientList(data);
      setAddAppointmentForm(initialAppointmentData);
      const newState = {
        ...addAppointmentForm,
        patients: [{ id: id, name: data.name }],
        dob: data.dob,
        email: "",
        contact: "",
      };
      setAddAppointmentForm(newState);
      setSelectedPatientDetails({
        name: data.name,
        dob: data.dob,
        emailList: data.emailList,
        contactList: data.contactList,
      });
    } catch (error) {}
  };

  const filterPatientList = async (patientList: any, subQuery: string) => {
    setSelectedPatientName(subQuery);
    const newState = {
      ...addAppointmentForm,
      patients: [],
      dob: "",
      email: "",
      contact: "",
    };
    setAddAppointmentForm(newState);
    const filtered = patientList.filter((patient: IdNamePair) => {
      if (subQuery && patient.name) {
        return patient.name?.toLowerCase().includes(subQuery.toLowerCase());
      }
    });
    setFilteredPatients(filtered);
  };

  const filterCoachList = (coachList: any, subQuery: string) => {
    const newState = {
      ...addAppointmentForm,
      coachList: [],
    };
    setAddAppointmentForm(newState);
    const filtered = coachList.filter((coach: IdNamePair) => {
      if (subQuery && coach.name) {
        return coach.name?.toLowerCase().includes(subQuery.toLowerCase());
      }
    });
    setFilteredCoaches(filtered);
  };

  const handlePatientSelection = (patient: IdNamePair) => {
    setSelectedPatientName(patient.name);
    getPatientDetailById(patient.id);
    setFilteredPatients([]);
  };
  const handleCoachSelection = (coach: IdNamePair) => {
    // getPatientDetailById(coach.id);
    const newState = {
      ...addAppointmentForm,
      coachList: [{ id: coach.id, name: coach.name }],
    };
    setAddAppointmentForm(newState);
    setSelectedCoachName(coach.name);
    setFilteredCoaches([]);
  };

  const targetChangeHandlar = (event: any) => {
    const newState = {
      ...addAppointmentForm,
      appointmentDatetime: event.value,
    };
    setAddAppointmentForm(newState);
  };
  const handleDropdownChanged = (event: any) => {
    const newState = {
      ...addAppointmentForm,
      [event.target.name]: event.target.value,
    };
    setAddAppointmentForm(newState);
  };
  const handleInputChange = (event: any) => {
    const newState = {
      ...addAppointmentForm,
      [event.target.name]: event.target.value,
    };
    setAddAppointmentForm(newState);
  };

  const saveAppointmentForm = async (event: any) => {

    event.preventDefault();
    setValidated(true)
    const form = event.currentTarget;
    if (!form.checkValidity()) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (radioOption === "OneOne") {
      const newState = {
        ...addAppointmentForm,
        status: "Planned",
        duration: "30",
      };
      setAddAppointmentForm(newState);
      try {
        await api.addAppointment(newState);

        setOpenToaster({
          message: "Appointment",
          show: true,
          type: "success",
        });
        getAllAppointments && getAllAppointments();
      } catch (error) {
        setOpenToaster({
          message: "Appointment",
          show: true,
          type: "error",
        });
      }
    }
  };

  const CalendarComp = (
    <div className="offcanvas-date-time">
      <label
        htmlFor="DateTime"
        className="form-label fs-12 fw-semibold mb-1"
      ></label>
      <Datepicker
        controls={["calendar", "time"]}
        value={addAppointmentForm.appointmentDatetime}
        theme="windows"
        themeVariant="light"
        display="inline"
        touchUi={true}
        onChange={(e) => targetChangeHandlar(e)}
        cssClass={"calendars"}
      />
    </div>
  );

  
  const selectCoach = (selected: any) => {
    setAddAppointmentForm({
      ...addAppointmentForm,
      coachList: selected && selected.key,
    });
  };

  const loadCoachesList = async (query: string) => {
    if (!query) {
      setCoachList([]);
      return;
    }
    try {
      const data = await api.getCoaches({ name: query });
      const options: DataListType[] = data.map((item: any) => ({
        key: item.id,
        value: `${item.firstName} ${item.lastName}`,
      }));
      setCoachList(options);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Form 
      noValidate
      validated={validated}
      >
    <div className="d-flex align-items-end flex-column h-100">
      <div>
        {CalendarComp}
        <div className="d-flex mb-3">
          <div className="flex-fill">
            <label
              htmlFor="AppointmentType"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Appointment Type
            </label>

            <select
              className="form-select form-select-sm"
              id="AppointmentType"
              value={addAppointmentForm.appointmentType}
              name="appointmentType"
              onChange={(e) => handleDropdownChanged(e)}
              required
            >
              <option value="">Select Type</option>
              {appointmentMetaData.appointmentTypeList.length > 0 &&
                appointmentMetaData.appointmentTypeList.map(
                  (type: IdLabelPair, index: number) => (
                    <option key={index} value={type.label}>
                      {type.label}
                    </option>
                  )
                )}
            </select>
          </div>
          <div className="ms-2 w-35">
            <label htmlFor="Mode" className="form-label fs-12 fw-semibold mb-1">
              Mode
            </label>
            <select
              className="form-select form-select-sm"
              id="Mode"
              value={addAppointmentForm.appointmentMode}
              name="appointmentMode"
              onChange={(e) => handleDropdownChanged(e)}
              required
            >
              <option value="">Select</option>
              {appointmentMetaData.appointmentModes.length > 0 &&
                appointmentMetaData.appointmentModes.map(
                  (type: IdLabelPair, index: number) => (
                    <option key={index} value={type.label}>
                      {type.label}
                    </option>
                  )
                )}
            </select>
          </div>
        </div>

        <div className="mb-3">
          <label
            htmlFor="RecurringOneTime"
            className="form-label fs-12 fw-semibold mb-1"
          >
            Recurring or One Time
          </label>
          <select
            className="form-select form-select-sm"
            id="RecurringOneTime"
            value={addAppointmentForm.occurrence}
            name="occurrence"
            onChange={(e) => handleDropdownChanged(e)}
            required
          >
            <option value="">Select Occurrence</option>
            {appointmentMetaData.appointmentOccurrenceList.length > 0 &&
              appointmentMetaData.appointmentOccurrenceList.map(
                (type: IdLabelPair, index: number) => (
                  <option key={index} value={type.label}>
                    {type.label}
                  </option>
                )
              )}
          </select>
        </div>

        

        <div className="mb-3">
          <label
            htmlFor="assignTo"
            className="form-label fs-12 fw-semibold mb-1"
          >
            Select coach
          </label>
          <AsyncTypeahead
            name="assignedTo"
            options={coachList}
            onSelect={selectCoach}
            callback={loadCoachesList}
            placeholder={"Search Coach / Wellinks User"}
            required={true}
          ></AsyncTypeahead>
        </div>
        <>
          <div className="mb-3">
            <label
              htmlFor="AddPatients"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Add Patients (optional)
            </label>
            <input
              type="text"
              name="assignedTo"
              className="form-control form-control-sm"
              id="AddPatients"
              placeholder="Search patient"
            />
          </div>
          
        </>

        <div className="mb-3">
          <label htmlFor="Notes" className="form-label fs-12 fw-semibold mb-1">
            Notes(optional)
          </label>
          <textarea
            name="notes"
            className="form-control form-control-sm"
            id="Notes"
            placeholder="Add relevent notes"
            rows={3}
            onInput={(e) => handleInputChange(e)}
          ></textarea>
        </div>
      </div>
    
    </div>
    </Form>
  );
};
export default AddGroupWebinar;